export default "__VITE_ASSET__1JWms2G6__"